import React from 'react';
import { Icon } from './Icon.js';
export const IconCanvasChartLine = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M9 6V4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4V6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M21 6L21 21L3 21L3 6L21 6Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M7.5 15L10.5 12L12 13.5L13.5 15L16.5 12", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCanvasChartLine.js.map